module.exports = __webpack_public_path__ + "static/img/icon8.7d3845a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/lottery/winning/icon8.png
// module id = Y04f
// module chunks = 6